exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".delete-cell[data-v-ff584ab0]{position:absolute;margin:-8px;font-size:16px;background:#fff;opacity:.9;border-radius:20px;-webkit-border-radius:20px;-moz-border-radius:20px;padding:2px;cursor:pointer;z-index:1}.order-body[data-v-ff584ab0]{position:relative}.upload-enabled[data-v-ff584ab0],.upload-icon[data-v-ff584ab0]{bottom:4px;position:absolute;right:4px}.upload-enabled[data-v-ff584ab0]{font-size:18px;fill:#fff}.upload-disabled[data-v-ff584ab0]{opacity:.5;fill:#ccc}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ff584ab0","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/franchise_component/order-layout/order-layout-box.vue
// module id = YXpb
// module chunks = 86